export { default } from "./PromotionsSection";
